module.exports = __webpack_public_path__ + "static/media/ONE.90803881.png";